<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Kinderopvangtoeslag als tegemoetkoming in kosten van geregistreerde opvang
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kinderopvang terwijl je werkt is zeker niet goedkoop. Daarom is er de kinderopvangtoeslag: een
                tegemoetkoming in de kosten van geregistreerde opvang. Lees hieronder de
                belangrijkste voorwaarden om kinderopvangtoeslag te kunnen krijgen.
                <div class="space10"></div>

                <b>Jij én je partner werken of volgen een opleiding, een inburgeringscursus of een traject naar werk</b><br/>
                Daardoor kunt u niet alle dagen zelf voor uw kind zorgen.<br/>
                - Je werkt. <br/>
                Je hoeft niet per se een vaste baan te hebben. Het gaat erom dat je (beiden) werkt. En dat je
                geld verdient met je werk. Dus ook als zzp’er, freelancer of artiest kom je in aanmerking voor
                kinderopvangtoeslag. Of als je een onderneming hebt of meewerkt in de zaak van je partner. <br/>
                - Je volgt een opleiding. <br/>
                De opleiding moet erkend zijn door het ministerie van Onderwijs, Cultuur en Wetenschap (OCW). Het is een
                erkende opleiding als je naar een middelbare school, mbo, hbo of universiteit gaat. Of als je voortgezet
                algemeen volwassenonderwijs (vavo) volgt. Het gaat niet om cursussen of workshops, maar om volledige
                opleidingen. <br/>
                - Je volgt een traject naar werk. <br/>
                Je volgt een traject naar werk als je aan een programma deelneemt om aan de slag te kunnen. Vaak gaat
                dat via het UWV of je ex-werkgever. Een voorbeeld van zo’n traject naar werk is een
                re-integratietraject.
                <br/>
                - Je volgt een inburgeringscursus. <br/>
                Volg je verplicht een inburgeringscursus? Je kunt dan kinderopvangtoeslag krijgen. Je moet de cursus dan
                wel volgen bij een goedgekeurde school.
                <br/>
                <div class="space10"></div>

                <b>De opvang is geregistreerd</b><br/>
                De gemeente checkt of de opvang goed en veilig is. Goedgekeurde opvang staat geregistreerd in het
                Landelijk Register Kinderopvang (LRK) en heeft een LRK-nummer. Zonder dit nummer kun je geen toeslag
                aanvragen.
                <div class="space10"></div>

                <b>Je kind woont bij je</b><br/>
                Je hebt alleen recht op kinderopvangtoeslag als je voldoet aan elk van de volgende 2 voorwaarden:<br/>
                - Jij en je kind wonen op hetzelfde adres.<br/>
                - Jij en je kind staan allebei op dit adres ingeschreven bij de gemeente.<br/>
                Bent u co-ouder? Dan zijn de regels anders.
                <div class="space10"></div>

                <b>Een deel van de kosten van de opvang betaal je zelf</b><br/>
                Met de kinderopvangtoeslag kun je niet alle kosten van de opvang betalen. Je betaalt ook altijd zelf een
                deel van de kosten. Dat is de verplichte eigen bijdrage. De Belastingdienst kan je vragen om met
                bankafschriften te
                bewijzen dat je de opvangkosten op tijd hebt betaald.<br/>
                Je betaalt op tijd als je de opvang betaalde binnen 6 maanden na afloop van het jaar waarin de
                opvangkosten gemaakt zijn. <br/>
                Betaal je zelf niet mee aan de kosten? Bijvoorbeeld als je gastouder je kind gratis opvangt. Dan heb je
                geen recht op kinderopvangtoeslag.
                <div class="space10"></div>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Zoveel gezinnen, zoveel situaties
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Woon of werk je in het buitenland? Ben je co-ouder of heb je een stief- of pleegkind? Volg je een
                inburgeringscursus? Of wil je meer weten over wat telt als werk en wat niet?
                <div class="space10"></div>
                Lees meer over deze situaties en de <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/kinderopvangtoeslag/kan-ik-kinderopvangtoeslag-krijgen/kan-ik-kinderopvangtoeslag-krijgen"
                    target="_blank">voorwaarden</a> die gelden voor het kinderopvangtoeslag.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Aanvragen binnen 3 maanden na aanvang opvang
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Heb je recht op kinderopvangtoeslag? Wacht niet te lang met aanvragen. Je loopt dan geld mis. Je zit
                goed als je de toeslag aanvraagt binnen
                3 maanden nadat de opvang is gestart. Kinderopvangtoeslag krijgt je dus niet automatisch, je moet het
                wel aanvragen.
                <div class="space10"></div>
                Je hoeft alleen voor je 1e kind kinderopvangtoeslag aan te vragen.<br/>
                Gaat er nog een broertje of zusje naar de opvang? Dan geef je gewoon een wijziging door.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                LRK-nummer
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Een LRK-nummer (Landelijk Register Kinderopvangnummer) is een uniek identificatienummer dat wordt
                toegewezen aan geregistreerde kinderopvanglocaties in Nederland. Dit nummer maakt deel uit van het
                systeem waarmee de overheid toezicht houdt op de kwaliteit van kinderopvangvoorzieningen.
                <div class="space10"></div>
                Je kinderopvangloactie kan het 8 cijferige nummer aan je verstrekken<br/>
                <div class="space10"></div>
                Let op: het LRK nummer moet voldoen aan een zgn. 11-proef. Is het geen juist (LRK) nummer? Dan zie je
                een melding in beeld ("BSN ongeldig"). Deze ietwat vreemd ogende melding geeft dus aan dat het nummer
                niet voldoet aan de 11-proef. Vul alsnog het juiste nummer in.
            </div>
        </div>


    </div>

</div>
